import React, { useMemo, forwardRef, useRef, useState } from "react"

function TwoColTable({
    name = "",
    columnData = null,
    data = null,
    footnote = undefined,
    footnote2 = undefined,
}, ref) {
    // eslint-disable-next-line no-unused-vars
    const [active, setActive] = useState(false)
    //   const tableRef = useRef(null)

    const containerClass = useMemo(
        () =>
            `two-col-table${active ? "two-col-table--active" : ""}`,
        [active]
    )
    return (
        <>
            <div className={`${containerClass}__table--wrapper ${name}__table--wrapper`}>
                <table>
                    <thead>
                        <tr>
                            {columnData?.map((item, index) => (
                                <th
                                    key={`th-${index}`}
                                    data-column={index}
                                    className={`!font-variation-extra-bold ${index === 0 ? "sticky-cell" : ""
                                        } ${[2, 3, 4].includes(index) ? "special-column" : ""}`}
                                >
                                    {item.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {footnote && <p className={`${containerClass}__footnote`}>{footnote}</p>}
            {footnote2 && (
                <p className={`${containerClass}__footnote`}>{footnote2}</p>
            )}
        </>
    )
}

export default forwardRef(TwoColTable)